import { listForms } from '@wix/ambassador-forms-v4-form/http';
import { Fieldset } from '@wix/ambassador-forms-v4-form/types';
import { extractHttpErrorDetails, isHttpError, withCancelToken, withHeaders } from '@wix/form-http-essentials';
import { normalizeFormSchema } from '@wix/form-schema';
import { toError } from '../common/error';
import { ControllerError } from './errors';
export const fetchForms = async ({ formIds, formKind, namespace, httpClient, errorMonitor, throwWhenFormMissing = true, additionalMetadata, errorHandler, language, signal })=>{
    const getForms = async ()=>{
        const headers = language ? {
            'X-Wix-Language': language
        } : undefined;
        try {
            const { data } = await errorHandler.withErrorHandler(()=>httpClient.request(withCancelToken(withHeaders(listForms({
                    formIds,
                    namespace,
                    kind: formKind,
                    fieldsets: [
                        Fieldset.NESTED_FORMS
                    ],
                    additionalMetadata
                }), headers), signal, httpClient)), {
                errorCodesMap: {}
            });
            return data.forms ?? [];
        } catch (error) {
            if (isHttpError(error)) {
                const httpError = extractHttpErrorDetails(error);
                errorMonitor.captureException(new Error(`Could not fetch forms`), {
                    contexts: {
                        ...httpError && {
                            httpError
                        }
                    }
                });
            } else {
                errorMonitor.captureException(toError(error));
            }
            errorHandler.showError(error);
            throw new ControllerError('Could not fetch forms', error);
        }
    };
    const forms = await getForms();
    const formsById = forms.reduce((result, form)=>{
        if (form.id) {
            result[form.id] = normalizeFormSchema(form);
        }
        return result;
    }, {});
    const hasMissingForm = formIds.find((formId)=>!formsById[formId]);
    if (throwWhenFormMissing && hasMissingForm) {
        const errorMessage = 'One or more forms are missing in the server response';
        errorMonitor.captureException(new Error(errorMessage));
        throw new ControllerError(errorMessage);
    }
    return formsById;
};

//# sourceMappingURL=fetch-forms.js.map